<template>
  <validation-observer
    v-slot="{ handleSubmit }"
    ref="validationObserver"
    tag="div"
    class="modern-card modal-card social-image-theme-form"
  >
    <b-loading
      :is-full-page="false"
      :active="isLoading"
      :can-cancel="false"
    />

    <header class="modern-card__header">
      Add theme
      <b-button
        class="modern-card__close-button"
        aria-label="close"
        icon-right="close"
        @click="$emit('close')"
      />
    </header>

    <section class="modern-card__body">
      <form class="modern-modal-form">
        <ModernField
          v-model="form.name"
          name="name"
          label="Name*"
          :rules="{
            required: true,
            latin_characters_digits_spaces: true
          }"
        >
          <ModernTextInput
            v-model="form.name"
            maxlength="50"
          />
        </ModernField>
      </form>
    </section>

    <footer class="modern-card__footer">
      <button
        type="button"
        class="button is-success outlined"
        @click="$emit('close')"
      >
        Cancel
      </button>

      <button
        type="button"
        class="button is-success"
        @click="handleSubmit(submit)"
      >
        ADD
      </button>
    </footer>
  </validation-observer>
</template>

<script>
import ModernField from '@/components/Form/Field/ModernField.vue';
import ModernTextInput from '@/components/Form/Input/ModernTextInput.vue';
import {
  create,
} from '@/api/marketing_materials_theme';
import { get } from 'lodash';

export default {
  name: 'MarketingMaterialsThemeForm',
  components: {
    ModernTextInput,
    ModernField,
  },

  props: {
    userTypeId: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      isLoading: false,
      form: {
        name: null,
      },
    };
  },

  methods: {
    async submit() {
      this.isLoading = true;

      const payload = {
        name: this.form.name,
        userTypeId: this.userTypeId,
      };

      try {
        const { data } = await create(payload);

        this.$buefy.toast.open({
          message: 'Update successful!',
          type: 'is-success',
          duration: 5000,
        });

        this.$emit('submit', { data });
        this.$emit('close');
      } catch (error) {
        const message = get(error, 'response.data.message', 'An unexpected error occurred, please contact support@enhancify.com');

        if (message === 'The theme already exist') {
          this.$refs.validationObserver.setErrors({ name: message });
        } else {
          this.$buefy.snackbar.open({
            message,
            actionText: ' ',
            position: 'is-top',
            indefinite: true,
            type: 'is-danger',
          });
        }
      }

      this.isLoading = false;
    },
  },
};
</script>

<style lang="stylus">
.social-image-theme-form
  max-width 500px
</style>
